import * as React from 'react';

// @ts-expect-error - imported from .js/.jsx file
import {InboundCallIcon} from 'shells/icon/svg/inbound-call-icon';
import {TextField} from 'shells/textfield/textfield';

import type {MeetingLocationType} from 'nutshell-graphql-types';
import type {MeetingUpdateInput} from 'nutshell-graphql-types';

import {SmallModalContent} from './small-modal-content';
import {SmallModalFooter} from './small-modal-footer';

type Props = {
    id: string;
    location: string | null | undefined;
    locationType: MeetingLocationType;
    onSave: (arg1: MeetingUpdateInput) => void;
    onFailToConnect: () => void;
    closeModal: () => void;
};

export function InboundCallModalContent(props: Props) {
    const [phone, setPhone] = React.useState<string | null | undefined>(
        props.locationType === 'INBOUND_CALL' ? props.location : null
    );

    return (
        <SmallModalContent
            header='Inbound phone call'
            icon={InboundCallIcon}
            subheader='The phone number you provide will be shared with all participants.'
        >
            <TextField
                // @ts-expect-error
                name='phone-number'
                placeholder='Phone number'
                value={phone || ''}
                onChange={(newValue) => {
                    setPhone(newValue);
                }}
            />
            <SmallModalFooter
                onFailToConnect={props.onFailToConnect}
                saveDisabled={!phone}
                onSave={() => {
                    props.onSave({
                        id: props.id,
                        location: phone,
                        locationType: 'INBOUND_CALL',
                    });
                }}
                closeModal={props.closeModal}
            />
        </SmallModalContent>
    );
}
